const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const GOOGLE_MAPS_CALLBACK_NAME = "onGoogleMapsLoaded";

let googleMapsPromise = null;

function loadGoogleMaps() {
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google.maps);
  }

  if (!googleMapsPromise) {
    googleMapsPromise = new Promise((resolve, reject) => {
      window[GOOGLE_MAPS_CALLBACK_NAME] = () => {
        delete window[GOOGLE_MAPS_CALLBACK_NAME];
        resolve(window.google.maps);
      };

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY ?? "")}&libraries=places&loading=async&callback=${GOOGLE_MAPS_CALLBACK_NAME}`;
      script.async = true;
      script.onerror = () => {
        script.remove();
        googleMapsPromise = null;
        reject(new Error("Google Maps failed to load"));
      };
      document.head.appendChild(script);
    });
  }

  return googleMapsPromise;
}

export { loadGoogleMaps };
